import React from "react";

const AboutPreview = () => {
  return (
    <section className="relative py-24 bg-gradient-to-br from-blue-50 via-white to-indigo-50 overflow-hidden">
      {/* Animated background accents */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute bottom-0 right-10 w-96 h-96 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

      <div className="container mx-auto px-6 lg:px-16 relative">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Image */}
          <div className="lg:w-1/2 relative">
            <div className="relative group">
              <img
                src="/assets/images/about/about-home.jpg"
                alt="About STISSA Technology LLP (TISSA Technology)"
                className="rounded-3xl shadow-2xl border border-gray-100 float-right lg:w-[70%] transform group-hover:scale-105 transition duration-700 ease-out"
              />
              {/* Floating glow effect */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-500/20 to-indigo-500/20 blur-2xl opacity-0 group-hover:opacity-100 transition duration-500"></div>
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:w-1/2">
            <div className="max-w-xl">
              <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-snug">
                7+ Years of <span className="text-indigo-600">Digital Success</span>
              </h2>

              <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                STISSA Technology LLP (TISSA Technology) has deep expertise in custom software and mobile
                application development, delivering innovative IT solutions that
                empower businesses to scale, optimize operations, and stay ahead
                in the digital era.
              </p>

              <div className="space-y-6">
                <div className="flex items-start p-4 rounded-xl bg-white/60 backdrop-blur-lg shadow-md hover:shadow-lg transition">
                  <div className="flex-shrink-0 bg-gradient-to-r from-blue-500 to-indigo-600 w-12 h-12 rounded-full flex items-center justify-center mr-4 text-white">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Future-ready applications that transform ideas into
                    intelligent solutions, driving measurable business outcomes.
                  </p>
                </div>

                <div className="flex items-start p-4 rounded-xl bg-white/60 backdrop-blur-lg shadow-md hover:shadow-lg transition">
                  <div className="flex-shrink-0 bg-gradient-to-r from-blue-500 to-indigo-600 w-12 h-12 rounded-full flex items-center justify-center mr-4 text-white">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Building strong partnerships to become a global leader in IT
                    solutions, aligning our growth with our clients’ success.
                  </p>
                </div>
              </div>

              <div className="mt-10">
                <a
                  href="/about-us"
                  className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold rounded-full shadow-lg hover:shadow-2xl hover:scale-105 transition duration-300"
                >
                  Know More
                  <svg
                    className="w-5 h-5 ml-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
